import React from "react";
// require("dotenv").config();
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  setAllLoadsNumber,
  setLoadsList,
  setLoadsList_isLoading,
  setCurrentPage,
} from "../../redux/load/load.actions";

import {
  // selectAllLoads,
  selectLoadsListIsLoading,
  selectCurrentPage,
} from "../../redux/load/load.selectors";

import WithSpinner from "../../HOC/WithSpinner.component";

import Pagination from "../../containers/Pagination/Pagination.container";
import ReqCardsList from "../../containers/ReqCardsList/ReqCardsList.container";
import { withRouter } from "react-router-dom";

const WithSpinnerReqCardsList = WithSpinner(ReqCardsList);

class PublicReqList extends React.Component {
  // state = {
  //   load_requests: [],
  //   current_page: 1,
  //   all_loads_no: 1,

  //   isLoading_ReqCardsList: true,
  // };

  state = {
    reqList_isLoading: true,
  };

  get_load_requests() {
    this.setState({ reqList_isLoading: true });

    fetch(`${process.env.REACT_APP_API}get_load_requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ page: this.props.currentPage }),
    })
      .then((res) => res.json())
      .then((res) => {
        // this.setState({ load_requests: res, isLoading_ReqCardsList: false });
        // console.log(res);
        this.props.setLoadsList(res);
        // this.props.setLoadsList_isLoading(false);
        this.setState({ reqList_isLoading: false });
      })
      .catch((e) => console.log(e.message, e));
  }

  get_all_loads_no() {
    fetch(`${process.env.REACT_APP_API}get_load_requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((res) => this.props.setAllLoadsNumber(res))
      .catch((e) => console.log(e.message, e));

    // .then(this.get_load_requests());
    // .then(console.log(this.state));
  }

  // update_currentPage = async (number) => {
  //   // await this.setState({ current_page: number, isLoading_ReqCardsList: true });
  //   // alert(number);
  //   await this.props.setCurrentPage(number);
  //   await this.props.setLoadsList_isLoading(true);
  //   // this.state.isLoading_ReqCardsList = true;
  //   this.get_load_requests();
  // };

  async componentDidMount() {
    // console.log("this.props.history", this.props.history.);
    // console.log(this.props.location);

    const nn = this.props.match.params.pageNo
      ? Number(this.props.match.params.pageNo)
      : 1;
    await this.props.setCurrentPage(nn);
    await this.props.setLoadsList_isLoading(true);

    await this.get_load_requests();
    await this.get_all_loads_no();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname === prevProps.location.pathname) {
      // debugger;
      // alert("hi");
      return;
    }
    //   console.log(this.should_update);
    // if (!this.should_update) return;

    // this.should_update = false;
    const nn = this.props.match.params.pageNo
      ? Number(this.props.match.params.pageNo)
      : 1;
    await this.props.setCurrentPage(nn);
    await this.props.setLoadsList_isLoading(true);

    await this.get_load_requests();
    await this.get_all_loads_no();
  }

  render() {
    // debugger;
    return (
      <div className="mx-3 mx-sm-4 mt-5 mb-2">
        <div className="mb-4">
          <Pagination
            loadRequests_no={30}
            // update_currentPage={this.update_currentPage}
          />
        </div>
        <WithSpinnerReqCardsList isLoading={this.state.reqList_isLoading} />
        <div className="mt-4">
          <Pagination
            loadRequests_no={30}
            // update_currentPage={this.update_currentPage}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  // allLoads: selectAllLoads,
  loadsListIsLoading: selectLoadsListIsLoading,
  currentPage: selectCurrentPage,
});

const mapDispatchToProps = (dispatch) => ({
  setLoadsList: (list) => dispatch(setLoadsList(list)),
  setAllLoadsNumber: (number) => dispatch(setAllLoadsNumber(number)),
  setLoadsList_isLoading: (bool) => dispatch(setLoadsList_isLoading(bool)),
  setCurrentPage: (page) => dispatch(setCurrentPage(page)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PublicReqList));
